import { decodeToken, isExpired as jwtIsExpired } from 'react-jwt';

export function getTokenPayload(token) {
    if (!token) return null;
    return decodeToken(token);
}

export async function isExpired(token) {
    if (!token) return true;
    return jwtIsExpired(token);
}
